/*eslint no-undef: "error"*/
<template>
  <div>
      <gmap-map :center="center" ref="myMap" :options="{streetViewControl: false}" :zoom="14" style="height: 100vh">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      </gmap-map>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import router from '../router'
import axios from 'axios'
export default {
  name: 'mapa',
  data () {
    return {
      nav: {
        edge: 'right'
      },
      URL: 'https://evocloud-guepardos.appspot.com/api',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajerosData: [],
      serviciosData: [],
      todosMensajeros: []
    }
  },
  mounted () {
    let vm = this
    this.getData()
    this.interval = setInterval(function () {
      this.getData()
    }.bind(this), 10000)
    vm.$http.get('http://evocloud-guepardos.appspot.com/api/Mensajeros')
    .then(data => {
      vm.todosMensajeros = data
    })
  },
  methods: {
    getData () {
      let vm = this
      axios.get('http://localhost:3005/api/v2/geopointsMensajeros')
      .then(data => {
        vm.mensajerosData = data.data
        /* axios.get('https://mensajeria.guepardos.co/api/v2/serviciosMapaMensajeros')
        .then(data => {
          vm.serviciosData = data.body
        }) */
        vm.dibujarMensajeros()
      })
    },
    dibujarMensajeros () {
      let vm = this
      vm.markers = []
      vm._.forEach(vm.mensajerosData, function (mensajero) {
        vm.markers.push({
          position: {
            lat: parseFloat(mensajero.ultimaPosicion.point.lat),
            lng: parseFloat(mensajero.ultimaPosicion.point.lng)
          },
          infoText: `${mensajero.nombre} - Placa: ${mensajero.placa} - Celular: ${mensajero.celular}`,
          icon: require('../assets/mensajero.png')
        })
      })
      vm._.forEach(vm.serviciosData, function (servicio) {
        let mensajero = vm.getMensajero(servicio.mensajeroId)
        let estado = vm.getEstado(servicio.estadoServicio)
        vm.markers.push({
          position: {
            lat: parseFloat(servicio.geoR.lat),
            lng: parseFloat(servicio.geoR.lng)
          },
          infoText: `${servicio.nombre} - estado: ${estado}`,
          icon: require('../assets/entrega.png')
        })
      })
    },
    getMensajero (idMensajero) {
      const vm = this
      let mensajero = vm._.find(vm.todosMensajeros, {'id': idMensajero})
      if (!mensajero) {
        mensajero = '-'
      } else {
        mensajero = mensajero.nombre
      }
      return mensajero
    },
    getEstado (estado) {
      let estadoServicio = '-'
      if (estado === 99) {
        estadoServicio = 'Pendiente'
      } else if (estado === 0) {
        estadoServicio = 'Asignado'
      } else if (estado === 1) {
        estadoServicio = 'Recogido'
      } else if (estado === 2) {
        estadoServicio = 'Entregado'
      } else if (estado === 3) {
        estadoServicio = 'finalizado'
      }
      return estadoServicio
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
</style>



// WEBPACK FOOTER //
// Mensajeros.vue?01f3ced1